import ApiService from './ApiService';

export default {
  /**
   * Finds a color map by ID
   * @param {number} id Color Map ID
   * @returns {Promise<any>}
   */
  findById(id) {
    return new Promise((resolve, reject) => {
      const data = {
        id,
      };
      ApiService.request('GET', 'colors/maps', data).then((response) => {
        if (response.status === 200 && response.data.length === 1) {
          resolve(response.data[0]);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  /**
   * Creates a new color map
   * @param {array} data Data
   * @returns {Promise<any>}
   */
  create(data) {
    return new Promise((resolve, reject) => {
      ApiService.request('POST', 'colors/maps', data).then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(error => {
        reject(error);
      });
    });
  },
  /**
   * Updates a color map
   * @param {number} id Color Map ID
   * @param {array} data Data
   * @returns {Promise<any>}
   */
  update(id, data) {
    return new Promise((resolve, reject) => {
      ApiService.request('PUT', `colors/maps/${id}`, data).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  /**
   * Remove a color map by ID
   * @param {number} id Color Map ID
   * @returns {Promise<any>}
   */
  remove(id) {
    return new Promise((resolve, reject) => {
      ApiService.request('DELETE', `colors/maps/${id}`, {}).then((response) => {
        resolve(response.data);
      }).catch(() => {
        reject(new Error());
      });
    });
  },
};
